import { render } from "./FileNodeEditor.vue?vue&type=template&id=73bd7dfc&ts=true"
import script from "./FileNodeEditor.vue?vue&type=script&lang=ts"
export * from "./FileNodeEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__